import { NavLogoKind } from "./types";

export function mustBeSubmenu(navLogoKind: NavLogoKind) {
	switch (navLogoKind) {
		case NavLogoKind.GetConnected:
			return true;
		default:
			return false;
	}
}
